import React, { useState } from 'react';
import AccountTooltip from './AccountTooltip';
import AccountButton from './AccountButton';
import { useTranslations } from '../translations';
import { ASSETS } from '../constants/assets';
import StorefrontIcon from './StorefrontIcon';
import { appLinkClick, createPageUrl } from '../utils/appRoutes';
import './Header.css';

interface HeaderProps {
  isLoggedIn?: boolean;
  isAdmin?: boolean;
  onNavigateToLogin: () => void;
  onNavigateToRegister: () => void;
  onNavigateToHome: () => void;
  onLogout?: () => void;
  onProfileClick?: () => void;
  onLocationsClick?: () => void;
  onMessagesClick?: () => void;
  onAnnouncementsClick?: () => void;
  onAdministrationClick?: () => void;
  onSettingsClick?: () => void;
  onNavigateToCreateProduct?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isLoggedIn = false,
  isAdmin = false,
  onNavigateToLogin,
  onNavigateToRegister,
  onNavigateToHome,
  onLogout,
  onProfileClick,
  onLocationsClick,
  onMessagesClick,
  onAnnouncementsClick,
  onAdministrationClick,
  onSettingsClick,
  onNavigateToCreateProduct
}) => {
  const t = useTranslations();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <header className="header">
      <a href="/" onClick={appLinkClick(onNavigateToHome)} className="logo">
        <img src={ASSETS.LOGO} alt="roade.ro" className="logo-image" />
      </a>
      <div className="header-actions">
        {!isAdmin && (
          <a
            className="btn-tertiary btn-with-icon header-add-listing"
            href={createPageUrl('createProduct')}
            onClick={appLinkClick(onNavigateToCreateProduct)}
          >
            <StorefrontIcon aria-hidden="true" />
            <span>{t.header.addListing}</span>
          </a>
        )}
        
        {isLoggedIn ? (
          <AccountButton
            text={t.header.myAccount}
            isAdmin={isAdmin}
            onProfileClick={onProfileClick}
            onLocationsClick={onLocationsClick}
            onMessagesClick={onMessagesClick}
            onAnnouncementsClick={onAnnouncementsClick}
            onAdministrationClick={onAdministrationClick}
            onSettingsClick={onSettingsClick}
            onLogoutClick={onLogout}
          />
        ) : (
          <div
            className="auth-button-wrapper"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <button className="btn-primary" onClick={onNavigateToLogin}>
              {t.header.login}
            </button>
            <AccountTooltip
              visible={showTooltip}
              onNavigateToLogin={onNavigateToLogin}
              onNavigateToRegister={onNavigateToRegister}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
